import MuiTab from "@mui/material/Tab";
const Tab = MuiTab;
export default Tab;
